import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import FeaturedCategories from './components/FeaturedCategories';
import WhySection from './components/WhySection';
import Reviews from './components/Reviews';
import CTABanner from './components/CTABanner';
import ArticlePreview from './components/ArticlePreview';
import FAQ from './components/FAQ';
import { WebSiteSchema, OrganizationSchema, BreadcrumbListSchema } from '@/components/base/SchemaOrg';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <WebSiteSchema />
      <OrganizationSchema />
      <BreadcrumbListSchema items={[{ name: 'OOPBuy Spreadsheet Deutschland', item: 'https://oopbuyspread.buzz/' }]} />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <FeaturedCategories />
        <WhySection />
        <Reviews />
        <CTABanner />
        <ArticlePreview />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}